export default __webpack_public_path__ + "static/media/logo1.03cbdc8c.png";